import {
    faFileExcel,
    faLayerGroup,
    faPlus,
    faDownload,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import useDepartment from './hooks/useDepartment'
import { getTemplate } from '../../Services/reporteService'
import Swal from 'sweetalert2'

const AddDepartamentoImportar = ({ history }) => {
    const { file, setFile, handleSubmit, isLoading } = useDepartment(history)

    const handleDownloadTemplate = async () => {
        try {
            const template = await getTemplate('departamentos')
            const byteCharacters = atob(template.data)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            const blob = new Blob([byteArray], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = 'template-departamentos.xlsx'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema al descargar el template.',
                showConfirmButton: true,
            })
        }
    }

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo
                        icon={faLayerGroup}
                        title={'Importar Departamentos'}
                    />
                </div>

                <div className="bg-gris p-4 position-relative">
                    {isLoading && (
                        <div
                            className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
                            style={{
                                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                top: 0,
                                left: 0,
                                zIndex: 10,
                            }}
                        >
                            <div className="text-center">
                                <div
                                    className="spinner-border text-success"
                                    role="status"
                                >
                                    <span className="sr-only">Cargando...</span>
                                </div>
                                <p className="mt-2 font-weight-bold">
                                    Importando departamentos...
                                </p>
                            </div>
                        </div>
                    )}

                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                        <div className="form-row justify-content-center">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputFile">
                                    Seleccione un archivo
                                </label>
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <FontAwesomeIcon icon={faFileExcel} />
                                    </span>
                                    <input
                                        type="file"
                                        id="inputFile"
                                        name="fileCSV"
                                        className="form-control"
                                        onChange={(e) =>
                                            setFile(e.target.files[0])
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="text-center">
                            <button
                                type="button"
                                className="btn btn-outline-primary mr-2"
                                onClick={handleDownloadTemplate}
                            >
                                <FontAwesomeIcon icon={faDownload} /> Plantilla
                            </button>
                            <button
                                type="submit"
                                className="btn btn-outline-success"
                                disabled={!file || isLoading}
                                style={{
                                    backgroundColor: !file ? '#e0e0e0' : '',
                                    borderColor: !file ? '#ccc' : '',
                                    cursor: !file ? 'not-allowed' : 'pointer',
                                }}
                            >
                                <FontAwesomeIcon icon={faPlus} /> Importar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(AddDepartamentoImportar)
